import { ThemeProvider } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./App";
import configStore from "./store/store";
import AuthConfig from "./config/AuthConfig";
// app theme
import { appTheme } from "./constants/Theme";
import { SnackbarProvider } from "notistack";
import SnackbarCloseButton from "./components/shared/snackbarCloseButton";
import {createRoot} from "react-dom/client";

const { persistor, store } = configStore();
export const pca = new PublicClientApplication(AuthConfig);

let rootElement = document.getElementById("root")
if (!rootElement) throw new Error('Failed to find the root element');
let root = createRoot(rootElement);
root.render(
    <MsalProvider instance={pca}>
    <Provider store={store}>
      <PersistGate
        loading={<Typography>Loading...</Typography>}
        persistor={persistor}
      >
        <ThemeProvider theme={appTheme}>
          <SnackbarProvider
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            preventDuplicate
            autoHideDuration={5000}
            maxSnack={4}
            action={(snackbarKey) => <SnackbarCloseButton id={snackbarKey} />}
          >
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </BrowserRouter>
          </SnackbarProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </MsalProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
